import React from "react";

const Omitting_Namespace = () => {
  return (
    <div>
      <h1>Omitting_Namespace Component</h1>
      <p>Content for Omitting_Namespace goes here...</p>
    </div>
  );
};

export default Omitting_Namespace;
